import type { HelpBullet, HelpStep } from '../vacationHelp.types';

function escapeHtml(text: string): string {
	const map: Record<string, string> = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;',
	};
	return text.replace(/[&<>"']/g, (char) => map[char]);
}

function renderBullet(bullet: string | HelpBullet): string {
	if (typeof bullet === 'string') {
		return `<li>${escapeHtml(bullet)}</li>`;
	}
	return `<li><span class="vacation-tour-tone vacation-tour-tone--${bullet.tone}">${escapeHtml(bullet.label)}</span> ${escapeHtml(bullet.text)}</li>`;
}

export function renderTourStep(step: HelpStep, stepNumber: number, totalSteps: number): string {
	const parts: string[] = [];

	const progress = Math.round((stepNumber / totalSteps) * 100);
	parts.push(`
		<div class="vacation-tour-header">
			<div class="vacation-tour-step-badge">PASSO ${stepNumber} DE ${totalSteps}</div>
			<div class="vacation-tour-progress">
				<div class="vacation-tour-progress-bar" style="width: ${progress}%"></div>
			</div>
		</div>
	`);

	if (step.description && !step.lead && !step.chips && !step.bullets && !step.tip) {
		parts.push(step.description);
		return parts.join('');
	}

	if (step.lead) {
		parts.push(`<p class="vacation-tour-lead">${escapeHtml(step.lead)}</p>`);
	}

	if (step.chips && step.chips.length > 0) {
		const chipsHtml = step.chips
			.map((chip) => `<span class="vacation-tour-chip">${escapeHtml(chip)}</span>`)
			.join('');
		parts.push(`<div class="vacation-tour-chips">${chipsHtml}</div>`);
	}

	if (step.bullets && step.bullets.length > 0) {
		const bulletsList = step.bullets.map(renderBullet).join('');
		parts.push(`<ul class="vacation-tour-bullets">${bulletsList}</ul>`);
	}

	if (step.tip) {
		parts.push(
			`<div class="vacation-tour-tip"><span class="vacation-tour-tip-icon">💡</span><span>${escapeHtml(step.tip)}</span></div>`
		);
	}

	return parts.join('');
}
